module.exports = __webpack_public_path__ + "img/fct.6603f1bf.svg";